import {Component, OnInit} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {SwaggerUrl} from "../../../models/swagger-url";
import {SwaggerControllerService} from "../../../services/swagger-url-controller/swagger-url-controller.service";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "swagger-url",
  templateUrl: "./swagger-url.component.html",
})
export class SwaggerUrlComponent extends TranslatedBaseError implements OnInit {

  public urls: SwaggerUrl[] = [];
  public url: string;
  public swaggerName: string;
  public editMode: boolean[] = [];
  public editType: string = "";
  public isLoading: boolean = false;
  public settingsModalOpened: boolean = false;
  public settingsData: SwaggerUrl = null;
  public tlsTypes = ["JCEKS", "JKS", "PKCS12"];

  constructor(private swaggerControllerService: SwaggerControllerService,
              toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.loadUrls();
  }

  public loadUrls() {
    this.swaggerControllerService.getAllUrls().subscribe(
        (data) => this.urls = data,
        (error) => this.showErrorMessage(error),
    );
  }

  public addUrl() {
      const url = new SwaggerUrl();
      url.url = this.url;
      url.name = this.swaggerName;
      this.swaggerControllerService.addUrl(url).subscribe(
          (data) => {
            this.responseSuccessful("New swagger url added!");
            this.loadUrls();
            this.url = "";
            this.swaggerName = "";
          },
          (error) => this.showErrorMessage(error),
      );
  }

  public editUrl(url: SwaggerUrl) {
    this.swaggerControllerService.updateUrl(url).subscribe(
        (data) => {
          this.responseSuccessful("Swagger url edited!");
          this.isLoading = false;
          this.loadUrls();
        },
        (error) => this.showErrorMessage(error),
    );
  }

  public removeUrl(isConfirmed, urlId: string) {
    if (isConfirmed) {
      this.swaggerControllerService.removeUrl(urlId).subscribe(
          (data) => {
            this.loadUrls();
          },
          (error) => this.showErrorMessage(error),
      );
    }
  }

  public resetEdit() {
    this.editMode = new Array(this.urls.length).fill(false);
    this.editType = "";
  }

  public openSettings(data) {
      this.settingsData = JSON.parse(JSON.stringify(data));
      this.settingsModalOpened = true;
  }

  public closeSettings() {
      this.settingsModalOpened = false;
      this.settingsData = null;
  }

  public saveSettings() {
      this.swaggerControllerService.updateUrl(this.settingsData).subscribe(
          (data) => {
              this.closeSettings();
              this.responseSuccessful("Url settings updated!");
              this.isLoading = false;
              this.loadUrls();
          },
          (error) => this.showErrorMessage(error),
      );
  }
}
